const Facility = {
    text: 'Facility',
    link: '/facility/facility-list',
    icon: 'icon-book-open'
};

const Tutorial = {
    text: 'Tutorial',
    link: '/tutorial/tutorial-list',
    icon: 'icon-book-open'
};

const User = {
    text: 'User',
    link: '/user/user-list',
    icon: 'icon-user'
};

const Home = {
    text: 'Home',
    link: '/home',
    icon: 'icon-home'
};

const Content = {
    text: 'Content',
    link: '/content/content-admin',
    icon: 'icon-book-open'
};

const Category = {
    text: 'Category',
    link: '/category/category-list',
    icon: 'icon-book-open'
};

const Newsfeed = {
    text: 'Newsfeed',
    link: '/newsfeed/newsfeed-list',
    icon: 'icon-book-open'
};

const AppLog = {
    text: 'AppLog',
    link: '/applog',
    icon: 'icon-book-open'
};

const Blob = {
    text: 'Documents',
    link: '/blob/blob-list',
    icon: 'icon-book-open'
};

const Upload = {
    text: 'Upload',
    link: '/upload',
    icon: 'icon-note'
};

const LogOut = {
    text: 'LogOut',
    link: '/login',
    icon: 'icon-logout'
};

const headingMain = {
    text: 'Main Navigation',
    heading: true
};

export const menu = [
    headingMain,
    Facility,
    Tutorial,
    User,
    //Home,
    Category,
    Content,
    Newsfeed,
    AppLog,
    Blob,
    //Upload,
    LogOut
];



// WEBPACK FOOTER //
// ./src/app/routes/menu.ts